var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.54469 4.83027L7.73248 0.424373C7.79617 0.296865 7.89411 0.189619 8.01534 0.114662C8.13656 0.0397048 8.27627 0 8.4188 0C8.56133 0 8.70103 0.0397048 8.82226 0.114662C8.94348 0.189619 9.04143 0.296865 9.10511 0.424373L11.2929 4.83027L16.1839 5.54101C16.3249 5.56057 16.4577 5.6194 16.5669 5.71079C16.6761 5.80217 16.7575 5.92243 16.8017 6.05783C16.8458 6.19324 16.851 6.33833 16.8167 6.47655C16.7824 6.61477 16.7098 6.74056 16.6074 6.83954L13.0689 10.2669L13.9043 15.109C14.0112 15.7305 13.3544 16.2038 12.7927 15.9107L8.4188 13.6235L4.04405 15.9107C3.48321 16.2046 2.82637 15.7305 2.93332 15.1082L3.76869 10.2661L0.230155 6.8387C0.128248 6.73965 0.0561739 6.61399 0.0221242 6.47601C-0.0119256 6.33804 -0.00658492 6.19328 0.037539 6.05819C0.0816628 5.9231 0.1628 5.80309 0.271728 5.71182C0.380657 5.62054 0.513006 5.56166 0.653734 5.54185L5.54469 4.83027Z",
    fill: "#FFB800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.82dcc8a71b8be45b4d17b7d98d63fe91.svg";
export { ForwardRef as ReactComponent };